import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ISearchProvider } from '../search-provider.interface';
import { ManagedProductSearchUseCase } from '../../../pages/managed-product/managed-product-search.usecase';

@Injectable({
  providedIn: 'root',
})
export class ManagedProductSearchProvider implements ISearchProvider {
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);
  readonly #searchUseCase = inject(ManagedProductSearchUseCase);
  readonly formGroup = this.#searchUseCase.formModel.formGroup;

  onClickSearch(): void {
    this.#searchUseCase.searchManegedProducts(this.formGroup.value);
  }

  onClickClear(): void {
    this.#router.navigate(['/managed-product'], { relativeTo: this.#route });
  }
}
